import { User } from '@apis/index'
import Button from '@components/button'
import Field from '@components/fields'
import { Form, Formik } from 'formik'
import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import AuthFooter from '../component/authFooter'
import AuthHeader from '../component/authHeader'
import {
  AuthCard,
  AuthContainer,
  AuthWrapper,
  BottomSection,
  FormContainer,
  FormInputsContainer,
  FormWrapper,
} from '../style'
import { AuthSchema } from '@validations/index'
import GoBack from '@components/back'

const ResetPassword = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const location = useLocation()

  const { phoneNo, countryCode, purpose, token } = location.state

  const initialValues = {
    phoneNo: phoneNo,
    token: token,
    newPassword: '',
    confirmPassword: '',
  }

  const [resetPasswordDetails, setResetPasswordDetails] = useState({
    phoneNo: phoneNo,
    token: token,
    newPassword: '',
  })

  const submitHandler = async (values: any) => {
    setLoading(true)
    const payload = {
      phoneNo: phoneNo,
      token: token,
      newPassword: values.newPassword,
    }
    try {
      const res = await User.resetPassword(payload)
      if (res) {
        setResetPasswordDetails({
          ...resetPasswordDetails,
          newPassword: values.newPassword,
        })
        navigate('/login', {
          state: {
            ...resetPasswordDetails,
            newPassword: values.newPassword,
          },
        })
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <AuthWrapper>
      <AuthCard>
        <AuthContainer>
          <GoBack visibleForDesktop={false} />
          <AuthHeader content="Reset" tag="Password" />

          <Formik
            initialValues={initialValues}
            enableReinitialize
            validationSchema={AuthSchema.resetPasswordValidationSchema}
            onSubmit={submitHandler}
          >
            {({ handleSubmit }) => {
              return (
                <FormWrapper>
                  <Form onSubmit={handleSubmit}>
                    <FormContainer>
                      <FormInputsContainer>
                        <Field.Password
                          placeholder="New Password"
                          name="newPassword"
                          label="Password"
                        />
                        <Field.Password
                          placeholder="Confirm Password"
                          name="confirmPassword"
                          label="Confirm Password"
                        />
                      </FormInputsContainer>
                      <BottomSection>
                        <AuthFooter
                          content="Don't have a Account ?"
                          tag="Signup Now"
                          onClick={() =>
                            navigate('/phone', {
                              state: {
                                purpose: 'Register',
                              },
                            })
                          }
                        />
                        <Button
                          title="Reset Password"
                          styleButton="width:100%;margin-top:40px;"
                          height={45}
                          type="submit"
                          loading={loading}
                        />
                      </BottomSection>
                    </FormContainer>
                  </Form>
                </FormWrapper>
              )
            }}
          </Formik>
        </AuthContainer>
      </AuthCard>
    </AuthWrapper>
  )
}

export default ResetPassword
